var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('section',{attrs:{"id":"dynamic-page"}},[_vm._v("\n\t\tLoading...\n\t")])])
}]

export { render, staticRenderFns }